import React, { useState, useEffect, useRef } from "react";
import { Cascader, CheckPicker, SelectPicker } from "rsuite";
import { connect, useDispatch, useSelector } from "react-redux";
import { getPerformanceDataAPI } from "../../queries/apiQueries";
import "./performance.scss";
import ScatterGraph from "./scatter";
import NewTrends from "./newTrends";
import { FILTERDATA } from "../../utils";
import { appInsights } from "../router";
import MainHeader from "../../components/Layouts/MainHeader";
import MainContent from "../../components/Layouts/MainContent";
import { Loader } from "../../components/common/Loader";

const Performance = (props: any) => {
	const allFilters = useSelector(
		(state: any) => state.CommonReducer.allFilters
	);

	const [selectedFilters, setSelectedFilters] = useState<{
		l1: string[];
		l2: string[];
		l3: string[];
		district: string[];
		supplier: string[];
	}>(allFilters);

	const [filterOptions, setFilterOptions] = useState({
		l1: new Array<{ option: string }>(),
		l2: new Array<{ option: string }>(),
		l3: new Array<{ option: string }>(),
		district: new Array<{ option: string }>(),
		supplier: new Array<{ option: string }>(),
	});

	const [rawData, setRawData] = useState<any>([]);
	const didMount: any = useRef(false);

	const [filteredData, setFilteredData] = useState<any>([]);
	const [isVisible, setIsVisible] = useState(false);

	/* Currently selected filter */
	const [currentSelection, setCurrentSelection] = useState("");

	const [scatterData, setScatterData] = useState<any>([]);

	const [heading, setHeading] = useState("Trends by Categories");
	const [isRightVisible, setIsRightVisible] = useState(false);
	const [finalTrendsData, setFinalTrendsData] = useState<any>([]);

	// may require for future requirement
	const [rangeX, setRangeX] = useState([0, 0]);
	const [clickedBubble, setClickedBubble] = useState<any>(null);

	const [backup, setBackUp] = useState<any>([]);

	const viewByLabels = [
		{
			label: "L1",
			value: '["l1","0"]',
		},
		{
			label: "L2",
			value: "l2",
			children: [
				{
					label: "Top 10",
					value: '["l2", "10"]',
				},
				{
					label: "Top 15",
					value: '["l2", "15"]',
				},
				{
					label: "Top 20",
					value: '["l2", "20"]',
				},
			],
		},
		{
			label: "L3",
			value: "l3",
			children: [
				{
					label: "Top 10",
					value: '["l3", "10"]',
				},
				{
					label: "Top 15",
					value: '["l3", "15"]',
				},
				{
					label: "Top 20",
					value: '["l3", "20"]',
				},
			],
		},
		{
			label: "District",
			value: '["district","0"]',
		},
		{
			label: "Supplier",
			value: "supplier",
			children: [
				{
					label: "Top 10",
					value: '["supplier", "10"]',
				},
				{
					label: "Top 15",
					value: '["supplier", "15"]',
				},
				{
					label: "Top 20",
					value: '["supplier", "20"]',
				},
			],
		},
	];

	const dispatch = useDispatch<any>();
	const [refLine, setRefLine] = useState({ x: 0, y: 0 });
	const [selectedView, setSelectedView] = useState("l1");
	const [count, setCount] = useState(0);
	const [isLoading, setIsLoading] = useState(true);

	const getPerformanceData = async () => {
		let res = await dispatch(getPerformanceDataAPI());
		// setFilteredData(res);
		setRawData(res);
	};

	useEffect(() => {
		appInsights.trackPageView({
			name: `Navigate to Performance by ${localStorage.getItem("name")}`,
		});
		getPerformanceData();
	}, []);

	useEffect(() => {
		props.onFilterChange(selectedFilters);
		if (!didMount.current) {
			if (selectedFilters.district.length > 0) {
				handleFilterUpdate(selectedFilters.district, "district", true);
			}

			if (selectedFilters.l1.length > 0) {
				handleFilterUpdate(selectedFilters.l1, "l1", true);
			}

			if (selectedFilters.l2.length > 0) {
				handleFilterUpdate(selectedFilters.l2, "l2", true);
			}

			if (selectedFilters.l3.length > 0) {
				handleFilterUpdate(selectedFilters.l3, "l3", true);
			}

			if (selectedFilters.supplier.length > 0) {
				handleFilterUpdate(selectedFilters.supplier, "supplier", true);
			}
			didMount.current = true;
		}
	}, [selectedFilters]);

	/* When filter selection changes, data is filtered and state is updated */
	const handleFilterUpdate = (
		selection: any,
		filter: string,
		onlyFilterData: boolean = false
	) => {
		setCurrentSelection(filter);
		if (filter == "district") {
			if (!onlyFilterData)
				setSelectedFilters({
					...selectedFilters,
					district: selection,
					l1: [],
					l2: [],
					l3: [],
					supplier: [],
				});

			setFilteredData(
				selection.length == 0
					? rawData
					: rawData.filter((i: any) => selection.includes(i.District))
			);
		} else if (filter == "l1") {
			if (!onlyFilterData)
				setSelectedFilters({
					...selectedFilters,
					l1: selection,
					l2: [],
					l3: [],
					supplier: [],
				});

			setFilteredData(
				selectedFilters.district.length == 0 && selection.length == 0
					? rawData
					: rawData.filter((i: any) => {
							return (
								(selectedFilters.district.includes(
									i.District
								) ||
									selectedFilters.district.length == 0) &&
								(selection.length == 0 ||
									selection.includes(i.L1))
							);
					  })
			);
		} else if (filter == "l2") {
			if (!onlyFilterData)
				setSelectedFilters({
					...selectedFilters,
					l2: selection,
					l3: [],
					supplier: [],
				});

			setFilteredData(
				selectedFilters.district.length == 0 &&
					selectedFilters.l1.length == 0 &&
					selection.length == 0
					? rawData
					: rawData.filter((i: any) => {
							return (
								(selectedFilters.district.includes(
									i.District
								) ||
									selectedFilters.district.length == 0) &&
								(selectedFilters.l1.length == 0 ||
									selectedFilters.l1.includes(i.L1)) &&
								(selection.length == 0 ||
									selection.includes(i.L2))
							);
					  })
			);
		} else if (filter == "l3") {
			if (!onlyFilterData)
				setSelectedFilters({
					...selectedFilters,
					l3: selection,
					supplier: [],
				});

			setFilteredData(
				selectedFilters.district.length == 0 &&
					selectedFilters.l1.length == 0 &&
					selectedFilters.l2.length == 0 &&
					selection.length == 0
					? rawData
					: rawData.filter((i: any) => {
							return (
								(selectedFilters.district.includes(
									i.District
								) ||
									selectedFilters.district.length == 0) &&
								(selectedFilters.l1.length == 0 ||
									selectedFilters.l1.includes(i.L1)) &&
								(selectedFilters.l2.length == 0 ||
									selectedFilters.l2.includes(i.L2)) &&
								(selection.length == 0 ||
									selection.includes(i.L3))
							);
					  })
			);
		} else if (filter == "supplier") {
			if (!onlyFilterData)
				setSelectedFilters({ ...selectedFilters, supplier: selection });

			setFilteredData(
				selectedFilters.district.length == 0 &&
					selectedFilters.l1.length == 0 &&
					selectedFilters.l2.length == 0 &&
					selection.length == 0
					? rawData
					: rawData.filter((i: any) => {
							return (
								(selectedFilters.district.length == 0 ||
									selectedFilters.district.includes(
										i.District
									)) &&
								(selectedFilters.l1.length == 0 ||
									selectedFilters.l1.includes(i.L1)) &&
								(selectedFilters.l2.length == 0 ||
									selectedFilters.l2.includes(i.L2)) &&
								(selectedFilters.l3.length == 0 ||
									selectedFilters.l3.includes(i.L3)) &&
								(selection.length == 0 ||
									selection.includes(i.master_vendor_name))
							);
					  })
			);
		}
		setClickedBubble(null);
	};

	useEffect(() => {
		if (currentSelection == "district") {
			setFilterOptions({
				...filterOptions,
				l1: [...new Set(filteredData.map((i: any) => i.L1))].map(
					(i: any) => {
						return { option: i };
					}
				),
				l2: [...new Set(filteredData.map((i: any) => i.L2))].map(
					(i: any) => {
						return { option: i };
					}
				),
				l3: [...new Set(filteredData.map((i: any) => i.L3))].map(
					(i: any) => {
						return { option: i };
					}
				),
				supplier: [
					...new Set(
						filteredData.map((i: any) => i.master_vendor_name)
					),
				].map((i: any) => {
					return { option: i };
				}),
			});
			// }
		} else if (currentSelection == "l1") {
			setFilterOptions({
				...filterOptions,
				l2: [...new Set(filteredData.map((i: any) => i.L2))].map(
					(i: any) => {
						return { option: i };
					}
				),
				l3: [...new Set(filteredData.map((i: any) => i.L3))].map(
					(i: any) => {
						return { option: i };
					}
				),
				supplier: [
					...new Set(
						filteredData.map((i: any) => i.master_vendor_name)
					),
				].map((i: any) => {
					return { option: i };
				}),
			});
		} else if (currentSelection == "l2") {
			setFilterOptions({
				...filterOptions,
				l3: [...new Set(filteredData.map((i: any) => i.L3))].map(
					(i: any) => {
						return { option: i };
					}
				),
				supplier: [
					...new Set(
						filteredData.map((i: any) => i.master_vendor_name)
					),
				].map((i: any) => {
					return { option: i };
				}),
			});
		} else if (currentSelection == "l3") {
			setFilterOptions({
				...filterOptions,
				supplier: [
					...new Set(
						filteredData.map((i: any) => i.master_vendor_name)
					),
				].map((i: any) => {
					return { option: i };
				}),
			});
		}
	}, [filteredData]);

	useEffect(() => {
		if (rawData) {
			setFilteredData(rawData);
			setFilterOptions({
				district: [...new Set(rawData.map((i: any) => i.District))].map(
					(i: any) => {
						return { option: i };
					}
				),
				l1: [...new Set(rawData.map((i: any) => i.L1))].map(
					(i: any) => {
						return { option: i };
					}
				),
				l2: [...new Set(rawData.map((i: any) => i.L2))].map(
					(i: any) => {
						return { option: i };
					}
				),
				l3: [...new Set(rawData.map((i: any) => i.L3))].map(
					(i: any) => {
						return { option: i };
					}
				),
				supplier: [
					...new Set(rawData.map((i: any) => i.master_vendor_name)),
				].map((i: any) => {
					return { option: i };
				}),
			});
		} /* else {
            didMount.current = true;
        } */
	}, [rawData]);

	const updateView = (view: string, value: string = "") => {
		setSelectedView(view);
		if (["l1", "district"].includes(view)) {
			// setL2View("");
			// setL3View("");
			// setSupplierView("");
			if (view == "district") {
				setHeading("Trends by Districts for Selected Categories");
			} else {
				setHeading("Trends by Categories");
			}
		} else if (view == "l2") {
			setCount(Number(value));
			// setL2View(value);
			setHeading("Trends by Sub-Categories");
		} else if (view == "l3") {
			setCount(Number(value));
			setHeading("Trends by Sub-Categories");
			// setL3View(value);
		} else if (view == "supplier") {
			// setSupplierView(value);
			setCount(Number(value));
			setHeading("Trends by Suppliers for selected categories");
		}
	};

	useEffect(() => {
		if (filteredData?.length > 0) {
			let lastYearMargin = 0;
			let lastYearRevenue = 0;
			let sales2018 = 0;
			let sales2023 = 0;
			for (let data of filteredData) {
				lastYearMargin += data.LastYear_Margin;
				lastYearRevenue += data.LastYear_Revenue;
				sales2018 += data.sales_2018;
				sales2023 += data.sales_2023;
			}
			setRefLine({
				x: Math.round(
					(Math.pow(sales2023 / sales2018, 1 / (2023 - 2018)) - 1) *
						100
				),
				y: Math.round((lastYearMargin * 100) / lastYearRevenue),
			});
		}
	}, [filteredData]);

	useEffect(() => {
		if (filteredData?.length > 0) {
			let dataMap = groupDataByCategory();
			let result = dataForTrendsChart(dataMap);
			let names: any = [];
			let sortedTrend = result.trends;

			// Sorting scatter data
			result.scatter.sort(
				(x: any, y: any) => y.lastQtrCost - x.lastQtrCost
			);
			let slicedData: any = result.scatter;

			if (["l2", "l3", "supplier"].includes(selectedView)) {
				slicedData = slicedData.slice(0, count);
				setScatterData([...slicedData]);
				// fetching names of entities from sorted data so that extracting info for trends is easier
				names = result.scatter.map((i) => i.name).slice(0, count);
				sortedTrend = result.trends.filter((data: any) =>
					names.includes(data.name)
				);
			} else {
				setScatterData([...result.scatter]);
			}

			/* let minX, maxX;
            maxX = Math.max(...slicedData.map((i: any) => i.YoYGrowth));
            minX = Math.min(...slicedData.map((i: any) => i.YoYGrowth)); */

			// update for future requirement
			// setRangeX([minX, maxX]);

			setBackUp(sortedTrend);
			sortedTrend.sort(
				(x, y) => y.data.netCost.last3M - x.data.netCost.last3M
			);
			setFinalTrendsData([...sortedTrend]);
			setIsLoading(false);
		}
	}, [filteredData, selectedView, count]);

	const groupDataByCategory = () => {
		let dataMap = new Map();
		for (let i = 0; i < filteredData.length; i++) {
			if (selectedView == "l1") {
				if (dataMap.has(filteredData[i].L1)) {
					dataMap.set(filteredData[i].L1, [
						...dataMap.get(filteredData[i].L1),
						filteredData[i],
					]);
				} else {
					dataMap.set(filteredData[i].L1, [filteredData[i]]);
				}
			} else if (selectedView == "district") {
				if (dataMap.has(filteredData[i].District)) {
					dataMap.set(filteredData[i].District, [
						...dataMap.get(filteredData[i].District),
						filteredData[i],
					]);
				} else {
					dataMap.set(filteredData[i].District, [filteredData[i]]);
				}
			} else if (selectedView == "l2") {
				if (dataMap.has(filteredData[i].L2)) {
					dataMap.set(filteredData[i].L2, [
						...dataMap.get(filteredData[i].L2),
						filteredData[i],
					]);
				} else {
					dataMap.set(filteredData[i].L2, [filteredData[i]]);
				}
			} else if (selectedView == "l3") {
				if (dataMap.has(filteredData[i].L3)) {
					dataMap.set(filteredData[i].L3, [
						...dataMap.get(filteredData[i].L3),
						filteredData[i],
					]);
				} else {
					dataMap.set(filteredData[i].L3, [filteredData[i]]);
				}
			} else if (selectedView == "supplier") {
				if (dataMap.has(filteredData[i].master_vendor_name)) {
					dataMap.set(filteredData[i].master_vendor_name, [
						...dataMap.get(filteredData[i].master_vendor_name),
						filteredData[i],
					]);
				} else {
					dataMap.set(filteredData[i].master_vendor_name, [
						filteredData[i],
					]);
				}
			}
		}
		return dataMap;
	};

	const dataForTrendsChart = (dataMap: any) => {
		let scatterArr = [];
		let finalTrendsDataArray = [];
		for (const [key, value] of dataMap) {
			const dataObj = {
				name: "",
				data: {
					netCost: {
						ytd: 0,
						last3M: 0,
						lastM: 0,
						currMonth: 0,
					},
					volume: {
						ytd: 0,
						last3M: 0,
						lastM: 0,
						currMonth: 0,
					},
					grossMargin: {
						ytd: 0,
						last3M: 0,
						lastM: 0,
						currMonth: 0,
						fy: 0,
					},
					sales: {
						fy: 0,
					},
				},
			};
			const scatterObj = {
				name: "",
				grossMargin: 0,
				// YoYGrowth: 0,
				cagr: 0,
				spend: 0,
				lastQtrCost: 0,
			};

			dataObj.name = key;
			scatterObj.name = key;
			// let yoyCostLY = 0;
			let sales2018 = 0;
			let sales2023 = 0;
			let spend = 0;
			let monthCount = 0;

			value.map((v: any) => {
				//Volume Total Addition
				dataObj.data.volume.ytd += v.YTD_VolumeTY;
				dataObj.data.volume.last3M += v.Last3Month_Volume;
				dataObj.data.volume.lastM += v.LastMonth_Volume;
				dataObj.data.volume.currMonth += v.CurrMonth_Volume;
				//netCost Total Addition
				// yoyCostLY += v.YTD_CostLY;
				spend += v.LastYear_Cost;
				dataObj.data.netCost.ytd += v.YTD_CostTY;
				dataObj.data.netCost.last3M += v.Last3Month_Cost;
				dataObj.data.netCost.lastM += v.LastMonth_Cost;
				dataObj.data.netCost.currMonth += v.CurrMonth_Cost;
				//grossMargin Total Addition
				dataObj.data.grossMargin.ytd += v.YTD_MarginTY;
				dataObj.data.grossMargin.last3M += v.Last3Month_Margin;
				dataObj.data.grossMargin.lastM += v.LastMonth_Margin;
				dataObj.data.grossMargin.currMonth += v.CurrMonth_Margin;
				monthCount = v.completedMonth;

				// Additional stuff for scatter
				dataObj.data.grossMargin.fy += v.LastYear_Margin;
				dataObj.data.sales.fy += v.LastYear_Revenue;
				sales2018 += v.sales_2018;
				sales2023 += v.sales_2023;
			});
			scatterObj.grossMargin = Math.round(
				(dataObj.data.grossMargin.fy * 100) / dataObj.data.sales.fy
			);
			// scatterObj.YoYGrowth = Math.round(dataObj.data.netCost.ytd * 100 / yoyCostLY);
			scatterObj.cagr =
				(Math.pow(sales2023 / sales2018, 1 / 5) - 1) * 100;
			scatterObj.lastQtrCost = dataObj.data.netCost.last3M;
			// Volume calc
			dataObj.data.volume.ytd /= monthCount;
			dataObj.data.volume.last3M /= 3;
			// dataObj.data.netCost.currMonth

			dataObj.data.netCost.ytd /= monthCount * dataObj.data.volume.ytd;
			dataObj.data.netCost.last3M /= 3 * dataObj.data.volume.last3M;
			dataObj.data.netCost.lastM /= dataObj.data.volume.lastM;
			dataObj.data.netCost.currMonth /= dataObj.data.volume.currMonth;

			dataObj.data.grossMargin.ytd /=
				monthCount * dataObj.data.volume.ytd;
			dataObj.data.grossMargin.last3M /= 3 * dataObj.data.volume.last3M;
			dataObj.data.grossMargin.lastM /= dataObj.data.volume.lastM;
			dataObj.data.grossMargin.currMonth /= dataObj.data.volume.currMonth;

			finalTrendsDataArray.push(dataObj);
			scatterObj.spend = spend;
			scatterArr.push(scatterObj);
		}
		return { scatter: scatterArr, trends: finalTrendsDataArray };
	};

	const onViewChange = (value: any) => {
		let val = JSON.parse(value);
		updateView(val[0], val[1]);
		setClickedBubble(null);
	};

	const handleScatterClick = (data: string) => {
		// const dup = JSON.parse(JSON.stringify());
		if (data == null) {
			setFinalTrendsData([...backup]);
			setClickedBubble(null);
		} else {
			setFinalTrendsData([
				...backup.filter((record: any) => record.name == data),
			]);
			setClickedBubble(data);
		}
	};
	return isLoading ? (
		<Loader />
	) : (
		<div className="performance-dashboard-container w-full">
			<MainHeader
				onVisibilityChange={setIsVisible}
				isRightVisible={isRightVisible}
				setIsRightVisible={setIsRightVisible}
				topContent={
					<div className="flex flex-col justify-center align-start min-w-[8vw] max-w-[8vw]">
						<span className="text-black capitalize font-bold text-fs14">
							View By:
						</span>
						<Cascader
							data={viewByLabels}
							searchable={false}
							placeholder="View By"
							cleanable={false}
							defaultValue='["l1","0"]'
							onChange={(value: string) => {
								onViewChange(value);
							}}
						/>
					</div>
				}
				bottomContent={
					<>
						<div className="flex flex-col justify-center align-start min-w-[8vw] max-w-[8vw]">
							<span className="text-black capitalize font-bold text-fs14">
								District
							</span>
							<CheckPicker
								data={
									filterOptions.district?.length
										? filterOptions.district
										: []
								}
								placeholder="All"
								labelKey="option"
								valueKey="option"
								value={selectedFilters.district || []}
								onChange={(value) =>
									handleFilterUpdate(value, "district")
								}
							/>
						</div>

						<div className="flex flex-col justify-center align-start min-w-[8vw] max-w-[8vw]">
							<span className="text-black capitalize font-bold text-fs14">
								L1
							</span>
							<CheckPicker
								data={
									filterOptions.l1?.length
										? filterOptions.l1
										: []
								}
								placeholder="All"
								labelKey="option"
								valueKey="option"
								value={selectedFilters.l1 || []}
								onChange={(value) =>
									handleFilterUpdate(value, "l1")
								}
							/>
						</div>

						<div className="flex flex-col justify-center align-start min-w-[8vw] max-w-[8vw]">
							<span className="text-black capitalize font-bold text-fs14">
								L2
							</span>
							<CheckPicker
								data={
									filterOptions.l2?.length
										? filterOptions.l2
										: []
								}
								placeholder="All"
								labelKey="option"
								valueKey="option"
								value={selectedFilters.l2 || []}
								onChange={(value) =>
									handleFilterUpdate(value, "l2")
								}
							/>
						</div>

						<div className="flex flex-col justify-center align-start min-w-[8vw] max-w-[8vw]">
							<span className="text-black capitalize font-bold text-fs14">
								L3
							</span>
							<CheckPicker
								data={
									filterOptions.l3?.length
										? filterOptions.l3
										: []
								}
								placeholder="All"
								labelKey="option"
								valueKey="option"
								value={selectedFilters.l3 || []}
								onChange={(value) =>
									handleFilterUpdate(value, "l3")
								}
							/>
						</div>

						<div className="flex flex-col justify-center align-start min-w-[8vw] max-w-[8vw]">
							<span className="text-black capitalize font-bold text-fs14">
								Supplier
							</span>
							<CheckPicker
								data={
									filterOptions.supplier?.length
										? filterOptions.supplier
										: []
								}
								placeholder="All"
								labelKey="option"
								valueKey="option"
								value={selectedFilters.supplier || []}
								onChange={(value) =>
									handleFilterUpdate(value, "supplier")
								}
								virtualized
							/>
						</div>
					</>
				}
			></MainHeader>

			<MainContent isVisible={isVisible} fullHeight={true}>
				<div className="chart-flex h-full">
					{scatterData.length > 0 && (
						<div className="scatter-container">
							<ScatterGraph
								clickedBubble={clickedBubble}
								handleClick={handleScatterClick}
								range={rangeX}
								view={selectedView}
								data={scatterData}
								threshold={refLine}
							></ScatterGraph>
						</div>
					)}
					{finalTrendsData.length && (
						<div className="trend-container">
							<NewTrends
								trendsData={finalTrendsData}
								isVisible={isVisible}
							/>
						</div>
					)}
				</div>
			</MainContent>
		</div>
	);
};

const mapDispatchToProps = (dispatch: any) => ({
	onFilterChange: (data: any) => dispatch({ type: FILTERDATA, data: data }),
});
export default connect(null, mapDispatchToProps)(Performance);
